import { connect } from 'react-redux';

import NotFound from 'components/NotFound';
import * as actions from 'state/actions';

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    ...state,
  };
};

const mapDispatchToProps = dispatch => ({
  trackEvent: ({ eventLabel, eventLocation }) =>
    dispatch(actions.trackNotFoundPageEvent({ eventLabel, eventLocation })),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotFound);
